import React, { useContext, useMemo } from 'react';
import { PatternLines } from '@visx/pattern';
import { DataContext } from '@visx/xychart';
import StripedGraphBackgroundModel from "../../models/background/StripedGraphBackgroundModel.js";
const patternPrefix = 'xy-chart-pattern';
export default function StripedGraphBackground(props) {
  const {
    model
  } = props;
  const cData = useContext(DataContext);
  const {
    theme,
    margin,
    width,
    height,
    innerWidth,
    innerHeight
  } = cData;
  const {
    backgroundColor,
    stripeColor,
    stripeWidth,
    stripeOrientation,
    patternId
  } = useMemo(() => {
    const backgroundColor = StripedGraphBackgroundModel.getBackgroundColor(model) || theme?.backgroundColor || '#fff';
    const stripeColor = StripedGraphBackgroundModel.getStripeColor(model) || theme?.gridStyles?.stroke;
    const stripeWidth = StripedGraphBackgroundModel.getStripeWidth(model);
    const stripeOrientation = StripedGraphBackgroundModel.getOrientation(model);
    const patternId = `${patternPrefix}-${stripeOrientation.join('-')}`;
    return {
      backgroundColor,
      stripeColor,
      stripeWidth,
      stripeOrientation,
      patternId
    };
  }, [theme?.backgroundColor, model]);

  // early return values not available in context
  if (width == null || height == null || margin == null || theme == null) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PatternLines, {
    id: patternId,
    width: 16,
    height: 16,
    orientation: stripeOrientation,
    stroke: stripeColor,
    strokeWidth: stripeWidth
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: width,
    height: height,
    fill: backgroundColor
  }), /*#__PURE__*/React.createElement("rect", {
    x: margin.left,
    y: margin.top,
    width: innerWidth,
    height: innerHeight,
    fill: `url(#${patternId})`,
    fillOpacity: 0.3
  }));
}